import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiSettings } from '../../docs-routes'

const TestConfigNotificationDescription = () =>
  <>
    <Header rank={5}>
      Global test config notifications settings
    </Header>
    <br />
    <Paragraph>
      The <b>Global test config notifications settings </b>allow you to stay informed by enabling notifications for every test configuration run. DAI can send notifications using email or webhooks (which are apps that communicate over HTTP, such as Slack or PagerDuty). To send global notifications, start by enabling <b>Send email notifications</b> or <b>Send webhook notifications</b>, or both in the <b>Global test config notification settings</b>.
      <br /><br />
      To configure email or webhook notifications for specific tests, go to the test configuration and select <b>Advanced Settings</b>.
      <br /><br />
      You can enable or disable notifications for each test configuration individually. Additionally, you can add multiple recipients for notifications, customizing the notification based on the status of the test results, whether they are failed, errored, cancelled, or passed. This feature gives you full control over how you communicate updates on your test configuration runs, ensuring timely and relevant notifications for effective test management.
      <br /><br />
      <LinkToDocusaurus path={daiSettings}>Learn more in the DAI documentation</LinkToDocusaurus>
    </Paragraph>
    <br />
  </>

export default TestConfigNotificationDescription
